import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bcd046a8&scoped=true&"
import script from "./SysReportTpl.js?vue&type=script&lang=js&"
export * from "./SysReportTpl.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd046a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcd046a8')) {
      api.createRecord('bcd046a8', component.options)
    } else {
      api.reload('bcd046a8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=bcd046a8&scoped=true&", function () {
      api.rerender('bcd046a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SysReportTpl/Index.vue"
export default component.exports